module.exports = __webpack_public_path__ + "static/media/image_1.e208f1cc.svg";